<template>
  <div>
    <!-- [ Modal form Edit Progress ] start -->
    <sweet-modal blocking :title="$t('modal_editBusinessUnitTaskProgress')" ref="editProgressForm" class="modal" v-on:close="closeModal">
      <!--{{companyProgressItem}}-->
      <!-- {{selectedRow}} -->
      <el-form :model="form" status-icon :rules="rules" ref="form" label-width="100px" class="demo-ruleForm">

        <template v-if="parentBill">
          <el-form-item label-width="0">
            <el-switch v-model="form.isBillable" :active-text="$t('modal_billing')"></el-switch>
          </el-form-item>

          <el-row v-if="form.isBillable" :gutter="60">
            <el-col :span="12">
              <el-form-item prop="assignmentsId" label-width="0">
                <el-select v-model="form.assignmentsId" :placeholder="$t('modal_assignments')" clearable style="width: 100%;">
                  <el-option v-for="item in form.assignments"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                    @click.native="selectAssignments(item)">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item prop="activitiesId" label-width="0">
                <el-select v-model="form.activitiesId" :placeholder="$t('modal_activities')" clearable style="width: 100%;">
                  <el-option v-for="item in form.activities"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row v-if="form.isBillable">
            <el-col :span="24">
              <el-form-item label-width="0" prop="title">
                <el-input v-model="form.title" :label="$t('modal_shortNote')"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </template>

        <el-form-item class="text-block" label-position="top" label-width="0">
          <vue2-custom-editor
            ref="editor"
            style="margin-bottom: 20px;"
            v-model="form.text"/>
          <!--<el-input type="textarea" placeholder="Text" v-model="form.text"></el-input>-->
        </el-form-item>
        <div class="reminder-block">
          <el-form-item :label="$t('modal_timeSpent')">
            <el-time-picker
              :disabled="!editTime"
              v-model="form.timeSpent"
              value-format='HHmm'
              format='HH:mm'
              :picker-options="{
                align: 'center'
              }"
              placeholder="Arbitrary time">
            </el-time-picker>
          </el-form-item>
          <div class="reminder-block_date">
            <el-form-item prop="isReminderActive" :label="$t('modal_setReminder')" label-width="120px">
              <el-checkbox name="type" @change="isReminderActiveChange(form.isReminderActive)" v-model="form.isReminderActive"></el-checkbox>
            </el-form-item>
            <el-form-item prop="reminderDate" label-width="20px">
              <el-date-picker
                      format="d MMM yy h : mm A"
                      :disabled="!form.isReminderActive"
                      v-model="form.reminderDate"
                      type="datetime"
                      :placeholder="$t('modal_pickADate')"
                      value-format="timestamp"
              >
              </el-date-picker>
            </el-form-item>
          </div>
          <!--<el-button slot="trigger" v-on:click="$refs.formReminder.open()" size="small" type="primary">Set Reminder</el-button>-->
        </div>
        <el-form-item label-width="0">
          <el-checkbox :disabled="!confirm" v-model="form.confirmed">Confirmed time</el-checkbox>
        </el-form-item>
        <!--<el-button slot="trigger" size="small" type="primary">Add Media</el-button>-->
        <!-- <div class="upload-media">
          <el-upload
                  class="upload-demo"
                  ref="upload"
                  action=""
                  :auto-upload="false"
                  :file-list="fileList">
            <el-button slot="trigger" size="small" type="primary">Add Media</el-button>
          </el-upload>
        </div> -->
        <el-form-item :label="$t('modal_progress')" prop="Progress" >
          <el-slider
                  v-model="form.progress"
                  :max="100"
                  :min="0"
                  :step="5"
                  show-stops>
          </el-slider>
        </el-form-item>
        <!-- <el-form-item label="Hours spent">
          <el-input placeholder="Hours spent" v-model="form.hoursSpent"></el-input>
        </el-form-item> -->
        <!-- <el-form-item label="Minutes spent">
          <el-input placeholder="Minutes spent" v-model="form.minutesSpent"></el-input>
        </el-form-item> -->
        <div class="flex-twocolumn">
            <el-form-item label-width="0">
              <el-switch v-model="form.notifyBusinessUnitTeam"></el-switch> {{$t('modal_notifyBusinessUnitTeam')}}
            </el-form-item>
            <el-form-item label-width="0">
              <el-switch v-model="form.notifyTaskTeam"></el-switch> {{$t('modal_notifyTaskTeam')}}
            </el-form-item>
            <el-form-item label-width="0">
              <el-switch v-model="form.notifyClients"></el-switch> {{$t('modal_notifyClients')}}
            </el-form-item>
            <el-form-item label-width="0">
              <el-switch v-model="form.notifyVendors"></el-switch> {{$t('modal_notifyVendors')}}
            </el-form-item>
        </div>

        <el-form-item class="modal__btn">
          <el-button @click="modalCancel('editProgressForm')">{{$t('general_cancel')}}</el-button>
          <el-button @click="submitForm('form')" type="primary">{{$t('general_submit')}}</el-button>
        </el-form-item>
      </el-form>
      <!--{{companyProgressItem}}-->
    </sweet-modal>
    <!-- [ Modal form Edit Progress ] end -->
  </div>
</template>

<script>
import Vue2CustomEditor from "../../vue-2-custom-editor";
import { SweetModal } from '@totalflow4/tfsweet-modal-vue'
import axios from 'axios'
export default {
  components: {
    SweetModal,
    Vue2CustomEditor,
  },
  props: ['editProgressForm', 'companyProgressItem', 'prevBusinessUnitTaskProgress', 'parentBill', 'assignmentList'],
  watch: {
    companyProgressItem: function (val) {
      this.confirm = this.companyProgressItem.permission.confirm
      this.editTime = this.companyProgressItem.permission.editTime

      this.form.confirmed = this.companyProgressItem.confirmed === null ? false : this.companyProgressItem.confirmed
      this.form.id = this.companyProgressItem.id;
      this.form.title = this.companyProgressItem.title;
      this.form.progress = Math.round(this.companyProgressItem.progress);
      this.form.text = this.companyProgressItem.text;
      // this.form.notifyBusinessUnitTeam = !!(this.companyProgressItem.notifyBusinessUnitTeam);
      // this.form.notifyTaskTeam = !!(this.companyProgressItem.notifyTaskTeam);
      // this.form.notifyClients = !!(this.companyProgressItem.notifyClients);
      // this.form.notifyVendors = !!(this.companyProgressItem.notifyVendors);

      this.form.isReminderActive = !!(this.companyProgressItem.isReminderActive);
      this.form.reminderDate = this.companyProgressItem.reminderDate * 1000;
      this.form.reminderDate = this.form.reminderDate === 0 ? null : this.form.reminderDate

      this.form.isBillable = !!this.companyProgressItem.isBillable;
      this.form.assignmentsId = this.companyProgressItem.assignmentId;
      if (this.form.assignmentsId) {
        this.form.assignments.forEach(element => {
          if (element.id === this.form.assignmentsId) this.form.activities = element.activities
        });
      }
      this.form.activitiesId = this.companyProgressItem.activityId;

      this.form.hoursSpent = this.companyProgressItem.hoursSpent.toString();
      this.form.minutesSpent = this.companyProgressItem.minutesSpent.toString();

      if(this.form.hoursSpent.length < 2){
        this.form.hoursSpent = '0' + this.form.hoursSpent
      }
      if(this.form.minutesSpent.toString().length < 2){
        this.form.minutesSpent = '0' + this.form.minutesSpent
      }

       this.form.timeSpent = this.form.hoursSpent + this.form.minutesSpent;
    },
    assignmentList(val) {
      this.form.assignments = val
    },
  },
  data() {
    var checkDate = (rule, value, callback) => {
      if (!value && this.form.isReminderActive) {
        return callback(new Error('Please input the date'));
      }else callback();
    };
    return {
      confirm: false,
      editTime: false,

      // Edit Progress Form
      businessUnitTaskId: 0,
      form: {
        isBillable: true,
        activitiesId: null,
        activities: [],
        assignmentsId: null,
        assignments: [],

        confirmed: false,
        id: null,
        progress: 0,
        text: '',
        timeSpent: '0000',
        hoursSpent: 0,
        minutesSpent: 0,
        notifyBusinessUnitTeam: false,
        notifyTaskTeam: true,
        notifyClients: false,
        notifyVendors: false,
        isReminderActive: false,
        reminderDate: '',
        title: '',
      },
      fileList:[],
      rules: {
        reminderDate: [{ validator: checkDate, trigger: 'blur' }]
      }
    }
  },
  methods: {
    selectAssignments(item) {
        this.form.activitiesId = null
        this.form.activities = item.activities
    },
    modalCancel(ref) {
      this.$refs[ref].close();
    },
    isReminderActiveChange(value){
      if(!value){
        this.$refs['form'].resetFields();
      }
    },
    closeModal() {
      this.$refs['form'].resetFields();
    },
    notification(title, message, type) {
      this.$notify({
        title: title,
        message: message,
        type: type
      });
    },
    submitForm(form) {
      if(this.form.progress < this.prevBusinessUnitTaskProgress){
        return this.notification("Notification", "Progress cannot be less", "warning")
      }
      console.log('---', 'submit create');
      this.$refs[form].validate((valid) => {
        if (valid) {
          let loader = this.$loading.show();

          if (this.form.timeSpent) {
            let time, hours, minutes;
            time = this.form.timeSpent;
            hours = time.slice(0, 2);
            minutes = time.slice(2, 4);
            this.form.hoursSpent = hours
            this.form.minutesSpent = minutes
          }
          if(this.form.reminderDate === ''){
            this.form.reminderDate = null
          }
          if (!this.form.isBillable) {
            this.form.title = ''
            this.form.activitiesId = null
            this.form.assignmentsId = null
          }
          axios
          .post(`/api/v1/businessUnitTaskProgresses/update?companyId=${this.$route.query.companyId}&businessUnitId=${this.$route.query.businessUnitId}&businessUnitTaskId=${this.businessUnitTaskId}&businessUnitTaskProgressId=${this.form.id}`, {
            confirmed: this.form.confirmed,
            text: this.form.text,
            progress: this.form.progress,
            notifyBusinessUnitTeam: this.form.notifyBusinessUnitTeam,
            notifyTaskTeam: this.form.notifyTaskTeam,
            notifyClients: this.form.notifyClients,
            notifyVendors: this.form.notifyVendors,
            hoursSpent: this.form.hoursSpent,
            minutesSpent: this.form.minutesSpent,
            isReminderActive: this.form.isReminderActive,
            reminderDate: this.form.reminderDate / 1000,
            title: this.form.title,
            isBillable: this.form.isBillable,
            activityId: this.form.activitiesId,
            assignmentId: this.form.assignmentsId,
          })
          .then(response => {
            if(response.data.success){
              this.notification(this.$i18n.t('notification_title_success'), this.$i18n.t('success_editProgressNote'), "success");
              this.$store.dispatch('getDepProgressesList', this.businessUnitTaskId)
              this.$refs.editProgressForm.close();
              this.$emit('submit')
              if (this.$refs.editor.uploadedImagesArray.length) {
                this.$store.dispatch('approveUploadedImages', {
                  fileUrlArr: this.$refs.editor.uploadedImagesArray,
                  entityId: this.form.id,
                  entityTypeId: 48 // bu progress
                })
              }
              if (this.$refs.editor.removedImages.length) this.$store.dispatch('deleteRemovedImages', this.$refs.editor.removedImages)
              loader.hide()
            }
            console.log(response)
          })
          .catch(error => {
            loader.hide()
            this.notification("Notification", error.response.data.message, "warning")
          });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
  },
}
</script>

<style lang="scss" scoped>
.modal {
  &__title {
    text-align: center;
  }
  &__btn {
    text-align: right;
  }
}

.text-block{
    display:flex;
    flex-direction:column;
  }
  .reminder-block{
    justify-content: space-between;
    display:flex;
    &_date{
      display:flex;
    }
  }
  .reminder-datepicker{
    margin-left:0;
  }
  .flex-twocolumn{
    display:flex;
    &_second-column{
      margin-left:20px;
    }
  }
  .flex-end{
    display:flex;
    justify-content:flex-end;
  }
  .sweet-modal-overlay{
    z-index:1000;
  }
  /*.remider{*/
    /*display:flex;*/
    /*justify-content:flex-end;*/
    /*margin-bottom:10px;*/
  /*}*/
  .upload-media{
    display:flex;
    justify-content:flex-end;
  }
</style>

<style lang="less">
  .flex-twocolumn{
    display:flex;
    .el-form-item__content{
      margin:0 12px;
      font-size:13px;
    }
  }
  .reminder-block{
    .el-date-editor.el-input{
      width: 160px;
    }
  }
</style>
